import React from "react";
import "./HeroPasserelleISS.css";
import { useTranslation, Trans } from "react-i18next";

// Si tu ajoutes plus tard des formats optimisés, décommente et importe-les :
// import heroAvif from "../../Pictuers/passerelle_hero@2x.avif";
// import heroWebp from "../../Pictuers/passerelle_hero@2x.webp";
// import heroMobileAvif from "../../Pictuers/passerelle_hero_m.avif";
// import heroMobileWebp from "../../Pictuers/passerelle_hero_m.webp";

export default function HeroPasserelleISS() {
  const { t } = useTranslation();
  // Image produit en colonne droite (PNG fond transparent demandé)
  const productImage = "/images/Pass_part.png";

  return (
    <section className="hero-iss" aria-labelledby="iss-title" role="region">
      {/* BACKGROUND (conservé pour compat, masqué via CSS comme dans HeroTelealarmeISS) */}
      <picture className="hero-iss-bg" aria-hidden="true">
        {/* <source media="(max-width: 640px)" srcSet={heroMobileAvif} type="image/avif" />
        <source media="(max-width: 640px)" srcSet={heroMobileWebp} type="image/webp" />
        <source srcSet={heroAvif} type="image/avif" />
        <source srcSet={heroWebp} type="image/webp" /> */}
        <img
          src={"/images/passerelle.jpg"}
          alt=""
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </picture>

      {/* Overlays graphiques (identiques) */}
      <div className="hero-iss-scrim" aria-hidden="true" />
      <div className="hero-iss-vignette" aria-hidden="true" />

      {/* CONTENU (même grille et mêmes classes que HeroTelealarmeISS) */}
      <div className="hero-iss-inner">
        <div className="iss-grid">
          {/* Colonne gauche : titre, sous-titre, CTA */}
          <div className="iss-col iss-col--copy">
            <header className="iss-header">
              <h1 id="iss-title" className="iss-title">{t("heroPasserelle.title")}</h1>
              <p className="iss-subtitle">
                <Trans
                  i18nKey="heroPasserelle.subtitle"
                  components={{ 0: <strong />, 1: <strong />, 2: <strong /> }}
                />
              </p>
            </header>

            <div className="hero-iss-actions" role="group" aria-label={t("heroPasserelle.actions_aria")}>
              <a
                href="/devis"
                className="btn-solid"
                aria-label={t("heroPasserelle.cta_aria")}
              >
                {t("heroPasserelle.cta")}
              </a>
            </div>
          </div>

          {/* Colonne droite : visuel produit */}
          <figure className="iss-col iss-col--media">
            <img
              src={productImage}
              alt={t("heroPasserelle.product_img_alt")}
              className="hero-iss-img"
              loading="eager"
              decoding="async"
            />
          </figure>
        </div>

        {/* JSON-LD (SEO Produit minimal) */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Product",
              name: t("heroPasserelle.jsonld_name"),
              image: [productImage],
              description: t("heroPasserelle.jsonld_description"),
              brand: { "@type": "Brand", name: "OPENlift" }
            })
          }}
        />
      </div>
    </section>
  );
}
